import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pc_desk = _resolveComponent("pc-desk")
  const _component_mobile_desk = _resolveComponent("mobile-desk")

  return (_ctx.device.display !== 1)
    ? (_openBlock(), _createBlock(_component_pc_desk, { key: 0 }))
    : (_openBlock(), _createBlock(_component_mobile_desk, { key: 1 }))
}